export default {
      id: "team-usage",
      viewBox: "0 0 50 50",
      url: "/" + "assets/sprite.svg#team",
      toString: function () {
        return this.url;
      }
    }